module.exports = __webpack_public_path__ + "img/img12(2).a060309d.jpg";